import React, { useState } from 'react';
import { ArrowRight, Phone, Mail, MapPin } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { Button } from './ui/button';
import { mockData } from '../mock';
import Captcha from './Captcha';

const ContactSection = () => {
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [searchParams] = useSearchParams();
  const serviceParam = searchParams.get('service');

  return (
    <section id="contact" className="contact-section" data-testid="contact-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Get In Touch</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">Let's discuss your financial goals</p>
        </div>
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <Phone size={24} />
              </div>
              <div className="contact-details">
                <h4 className="contact-label">Phone</h4>
                <p className="contact-value">{mockData.contact.phone}</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <Mail size={24} />
              </div>
              <div className="contact-details">
                <h4 className="contact-label">Email</h4>
                <p className="contact-value">{mockData.contact.email}</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <MapPin size={24} />
              </div>
              <div className="contact-details">
                <h4 className="contact-label">Address</h4>
                <p className="contact-value">{mockData.contact.address}</p>
              </div>
            </div>
          </div>
          <div className="contact-form-wrapper">
            <form className="contact-form" data-testid="contact-form" onSubmit={(e) => {
              e.preventDefault();
              if (!isCaptchaValid) {
                alert('Please verify the captcha code before submitting.');
                return;
              }
              alert('Message sent successfully!');
              e.target.reset();
              setIsCaptchaValid(false);
            }}>
              <input type="text" placeholder="Your Name" className="form-input" data-testid="contact-name-input" required />
              <input type="email" placeholder="Your Email" className="form-input" data-testid="contact-email-input" required />
              <input type="tel" placeholder="Your Phone" className="form-input" data-testid="contact-phone-input" required />
              <textarea placeholder="Your Message" rows="4" className="form-textarea" data-testid="contact-message-input" required defaultValue={serviceParam ? `I am interested in: ${serviceParam}` : ''}></textarea>
              <Captcha onValidate={setIsCaptchaValid} />
              <Button type="submit" className="btn-primary form-submit" data-testid="contact-submit-btn" disabled={!isCaptchaValid}>
                Send Message <ArrowRight size={20} />
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
